import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import UserBadge from './UserBadge';
import "./style-new.css";

import {
  FaHome,
  FaRegArrowAltCircleDown,
  FaSave,
  FaPlus,
  FaEdit,
  FaArrowUp,
  FaFolderOpen,
  FaFutbol,
  FaMinus,
  FaTrash,
  FaSignOutAlt,
} from "react-icons/fa";

import { GrUpgrade } from "react-icons/gr";


const GroupActions = ({ groupId, isAdmin, onEditClick }) => {
  const navigate = useNavigate();

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this group?')) return;
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`/api/groups/${groupId}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.ok) {
        alert('Group deleted successfully.');
        navigate('/');
      } else {
        const data = await response.json();
        alert(data.message || 'Failed to delete the group.');
      }
    } catch (error) {
      console.error('Error deleting group:', error);
      alert('Failed to delete the group.');
    }
  };

  return (
    <div style={{ marginTop: '10px' }}>
      <button className="btn btn-primary" onClick={() => navigate('/')} style={{ marginRight: '10px' }}>
        <FaHome />
        Home
      </button>

      {isAdmin && (
        <>
          <button
            className="btn pastel-blue"
            onClick={() => navigate(`/group/${groupId}/add-member`)}
            style={{ marginRight: '10px' }}
          >
            <FaPlus />
            Add Member
          </button>
          <button
            className="btn pastel-yellow"
            onClick={onEditClick}
            style={{ marginRight: '10px' }}
          >
            <FaEdit />
            Edit Group Name
          </button>
          <button className="btn pastel-red" onClick={handleDelete}>
            <FaTrash />
            Delete Group
          </button>
        </>
      )}
    </div>
  );
};

const MemberList = ({ members, currentUserId, isAdmin, onRemove, onToggleAdmin }) => {
  if (!members.length) return <p>No members found for this group.</p>;

  return (
    <ul style={{ marginTop: '20px' }} className="no-list-style">
      {members.map((member) => (
        <li key={member.id} style={{ marginBottom: '12px' }}>
          <strong>
            {member.name} {member.surname}
          </strong>{' '}
          {member.is_admin && <span style={{ color: 'green' }}>(Admin)</span>}

          {isAdmin && member.id !== currentUserId && (
            <>
              <button
                className="btn pastel-red small-btn"
                onClick={() => onRemove(member.id)}
                style={{ marginLeft: '10px' }}
              >
              <FaMinus />
                Remove
              </button>
<button
  className={`btn small-btn ${member.is_admin ? 'pastel-yellow' : 'pastel-green'}`}
  onClick={() => onToggleAdmin(member.id, member.is_admin)}
  style={{ marginLeft: '10px' }}
>
  {member.is_admin ? <FaRegArrowAltCircleDown style={{ marginRight: '5px' }} /> : <GrUpgrade style={{ marginRight: '5px' }} />}
  {member.is_admin ? 'Remove Admin' : 'Make Admin'}
</button>

            </>
          )}
        </li>
      ))}
    </ul>
  );
};

const GroupDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [group, setGroup] = useState(null);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [editing, setEditing] = useState(false);
  const [editedName, setEditedName] = useState('');

const currentUser = JSON.parse(localStorage.getItem('currentUser'));
const currentUserId = currentUser?.id || null;
console.log("Loaded currentUser from localStorage:", currentUser);
console.log("Current User ID:", currentUserId);

  const token = localStorage.getItem('authToken');

  useEffect(() => {
    fetchGroupData();
  }, [id]);

  const fetchGroupData = async () => {
    setLoading(true);
    try {
      const groupRes = await fetch(`/api/groups/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const groupData = await groupRes.json();
      if (groupRes.ok) {
        setGroup(groupData.group);
        setEditedName(groupData.group.name);
      } else throw new Error(groupData.message || 'Failed to load group details.');

      const membersRes = await fetch(`/api/groups/${id}/members`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const membersData = await membersRes.json();
      if (membersRes.ok) {
        setMembers(membersData.members);
        console.log('Members list:', membersData.members);
      } else throw new Error(membersData.message || 'Failed to load members.');
    } catch (err) {
      console.error(err);
      setError(err.message || 'An error occurred while loading group details.');
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveMember = async (memberId) => {
    if (!window.confirm('Are you sure you want to remove this member?')) return;
    try {
      const response = await fetch(`/api/groups/${id}/members/${memberId}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      if (response.ok) {
        setMembers((prev) => prev.filter((m) => m.id !== memberId));
      } else {
        alert(data.message || 'Failed to remove member.');
      }
    } catch (err) {
      console.error('Error removing member:', err);
      alert('An error occurred while trying to remove the member.');
    }
  };

  const handleToggleAdmin = async (memberId, currentlyAdmin) => {
    try {
      const response = await fetch(`/api/groups/${id}/members/${memberId}/admin`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ makeAdmin: !currentlyAdmin }),
      });
      if (response.ok) {
        fetchGroupData(); // Refresh after change
      } else {
        const data = await response.json();
        alert(data.message || 'Failed to update admin status.');
      }
    } catch (err) {
      console.error('Error updating admin status:', err);
      alert('An error occurred while updating admin status.');
    }
  };

  const handleEditClick = () => {
    setEditing(true);
  };

  const handleSaveGroupName = async () => {
    try {
      const res = await fetch(`/api/groups/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ name: editedName }),
      });
      const data = await res.json();
      if (res.ok) {
        setGroup((prev) => ({ ...prev, name: editedName }));
        setEditing(false);
      } else {
        alert(data.message || 'Failed to update group name.');
      }
    } catch (err) {
      console.error('Error updating group name:', err);
      alert('An error occurred while updating group name.');
    }
  };

  const isAdmin = members.find((m) => m.id === currentUserId)?.is_admin || false;

  console.log('Current User ID:', currentUserId);
  console.log('Is Admin:', isAdmin);
  console.log('Group:', group);

  if (loading) return <p>Loading group details...</p>;
  if (error) return <p className="error-text">{error}</p>;

  return (
    <div className="page-container">
      <div className="center-content">
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
          <UserBadge />
        </div>

        {editing ? (
          <div style={{ marginBottom: '10px' }}>
            <input
              type="text"
              value={editedName}
              onChange={(e) => setEditedName(e.target.value)}
              style={{ padding: '8px', width: '300px' }}
            />
            <button
              className="btn pastel-green"
              onClick={handleSaveGroupName}
              style={{ marginLeft: '10px' }}
            >
              <FaSave />
              Save
            </button>
          </div>
        ) : (
          <>
            <h2 className="welcome-heading">{group?.name || 'Unnamed Group'}</h2>
            <p>
              Created on:{' '}
              {group?.created_at ? new Date(group.created_at).toLocaleString() : 'Unknown'}
            </p>
          </>
        )}

        <GroupActions groupId={id} isAdmin={isAdmin} onEditClick={handleEditClick} />

        <MemberList
          members={members}
          currentUserId={currentUserId}
          isAdmin={isAdmin}
          onRemove={handleRemoveMember}
          onToggleAdmin={handleToggleAdmin}
        />
      </div>
    </div>
  );
};

export default GroupDetail;
